module.exports = "//public.getcloudapp.com/packs/media/images/icons-transcribe-dccd9d6e32871fa971b7715f6cecf73e.svg";